import styled from "styled-components";

export const SliderImagesPreview = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`;

export const SliderImagePreview = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
  cursor: pointer;
`;

export const SliderImagePreviewContainer = styled.div`
  width: 100%;
  position: relative;

  &:hover {
    & > div {
      display: flex;
    }
  }

  & > div {
    display: none;
  }
`;

export const EmptyMessage = styled.span`
  color: ${({ theme }) => theme.text.text};
  opacity: 0.6;
  font-size: 14px;
`;

export const SliderImagePreviewActions = styled.div`
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  background-color: ${({ theme }) => theme.bg.general};
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 8px;
  border-radius: 12px;
  box-shadow: 0 1.171px 5.854px 0 rgba(63, 65, 66, 0.2);
  padding: 8px;
`;

export const SliderImagePreviewButton = styled.div`
  cursor: pointer;
  height: 20px;
`;
